import type { FC } from 'react';

import SunshineCard from 'components/_core/SunshineCard';

interface TransferInformationRowProps {
  label: string;
  value: string;
  isBold?: boolean;
}

const TransferInformationRow: FC<TransferInformationRowProps> = ({
  isBold = true,
  label,
  value,
}) => {
  return (
    <SunshineCard alignItems="flex-start">
      <SunshineCard.Content paddingTop="space-0">
        <SunshineCard.Text size="md">{label}</SunshineCard.Text>
      </SunshineCard.Content>

      <SunshineCard.Slot name="action">
        <SunshineCard.Text
          fontWeight={isBold ? 'weight-500' : undefined}
          overflow="hidden"
          size="md"
          textAlign="right"
          variant="primary"
        >
          {value}
        </SunshineCard.Text>
      </SunshineCard.Slot>
    </SunshineCard>
  );
};

export default TransferInformationRow;
